import classNames from 'classnames';
import './index.css';

type Props = {
    type: 'error';
    children: JSX.Element | string;
};

const Alert = ({ type, children }: Props) => {
    return (
        <div
            className={classNames('UI-Alert', {
                'UI-Alert--error': type === 'error',
            })}
        >
            {children}
        </div>
    );
};

export { Alert };
